import { TranslationKeys } from '../english/ui.i18n';

export const keys: TranslationKeys = {
  buttons: {
    home: "Retour à l'accueil",
    languageToggle: 'En',
  },
  ui: {
    navigation: {
      back: 'Retour',
      next: 'Suivant',
      cancel: 'Annuler',
    },
    navbar: {
      referral: 'Gagnez ${{0}}',
      tooltip: {
        referral: 'Gagnez ${{0}}',
        notifications: 'Notifications',
        helpMenu: 'Menu aide',
        userMenu: 'Menu utilisateur',
      },
      menu: {
        policies: 'Mes Polices',
        profile: 'Profil',
        logout: 'Déconnexion',
        helpCenter: "Centre d'aide",
        contactUs: 'Nous joindre',
      },
    },
  },
};

export default keys;
